import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { CustomSuggestTerm } from 'ish-core/models/suggest-term/custom-suggest-term.model';
import { Suggestions } from 'ish-core/models/suggestions/suggestions.model';
import { SuggestionsServiceInterface } from 'ish-core/service-provider/suggestions.service-provider';
import { ApiService, unpackEnvelope } from 'ish-core/services/api/api.service';

/**
 * The Suggest Service handles the interaction with the 'suggest' REST API.
 */
@Injectable({ providedIn: 'root' })
export class SuggestService implements SuggestionsServiceInterface {
  constructor(private apiService: ApiService) {}

  /**
   * Returns a list of suggested search terms matching the given search term.
   *
   * @param searchTerm  The search term to get suggestions for.
   * @returns           Suggestions with keywords section containing the suggested search terms.
   */
  searchSuggestions(searchTerm: string): Observable<{ suggestions: Suggestions }> {
    const params = new HttpParams().set('SearchTerm', searchTerm);
    return this.apiService.get('suggest', { params }).pipe(
      unpackEnvelope<{ term: string }>(),
      map(suggestTerms => ({
        keywords: suggestTerms.map(term => ({
          keyword: term.term,
        })),
      })),
      map(suggestions => ({ suggestions }))
    );
  }

  /* DIAS CUSTOMIZATION START */
  /**
   * Returns a list of suggested search terms including types matching the given search term.
   *
   * @param searchTerm  The search term to get suggestions for.
   * @returns           List of suggested products, categories and brands.
   */

  customSearch(searchTerm: string): Observable<CustomSuggestTerm[]> {
    const params = new HttpParams().set('SearchTerm', searchTerm);
    return this.apiService.get('customsuggest', { params }).pipe(unpackEnvelope<CustomSuggestTerm>());
  }
  /* DIAS CUSTOMIZATION END */
}
